.overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 101;
  cursor: pointer;
}

/* VIEW ARCHIVE Tooltip - dynamically positioned */
.tooltipArchive {
  position: fixed;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 16px;
  pointer-events: none;
}

.arrowCurved {
  width: 80px;
  height: 90px;
  align-self: flex-end;
}

/* START READING Tooltip - dynamically positioned */
.tooltipStartReading {
  position: fixed;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  pointer-events: none;
  transform: translate(-50%, -100%);
}

.arrowDown {
  width: 29px;
  height: 116px;
}

/* Text Content */
.tooltipContent {
  display: flex;
  flex-direction: column;
  gap: 13px;
}

.alignRight {
  text-align: right;
  align-items: flex-end;
}

.alignCenter {
  text-align: center;
  align-items: center;
}

.tooltipTitle {
  color: #fff;
  font-family: "Open Sans", sans-serif;
  font-size: 24px;
  font-weight: 700;
  line-height: 22.5px;
  letter-spacing: 0.75px;
  text-transform: uppercase;
  margin: 0;
}

.tooltipText {
  color: #fff;
  font-family: "Inter", sans-serif;
  font-size: 15px;
  font-weight: 700;
  line-height: 22.5px;
  margin: 0;
}

/* Responsive - Tablet */
@media screen and (max-width: 1024px) {
  .arrowCurved {
    width: 60px;
    height: 68px;
  }

  .tooltipTitle {
    font-size: 20px;
  }

  .tooltipText {
    font-size: 14px;
  }

  .arrowDown {
    width: 24px;
    height: 90px;
  }
}

/* Responsive - Mobile */
@media screen and (max-width: 480px) {
  .arrowCurved {
    width: 50px;
    height: 57px;
  }

  .tooltipTitle {
    font-size: 16px;
    line-height: 18px;
  }

  .tooltipText {
    font-size: 12px;
    line-height: 18px;
  }

  .arrowDown {
    width: 20px;
    height: 70px;
  }

  .tooltipContent {
    gap: 8px;
  }

  .tooltipArchive,
  .tooltipStartReading {
    gap: 12px;
  }
}
